import { Controller } from "@hotwired/stimulus"

// Autocomplete controller for reference fields
export default class extends Controller {
  static targets = ["input", "results"]
  static values = { type: String }

  connect() {
    this.timeout = null
    this.hideResults()
  }

  search() {
    clearTimeout(this.timeout)
    
    const query = this.inputTarget.value.trim()
    if (query.length < 2) {
      this.hideResults()
      return
    }

    this.timeout = setTimeout(() => {
      this.fetchResults(query)
    }, 300)
  }

  async fetchResults(query) {
    try {
      const params = new URLSearchParams({
        q: query,
        type: this.typeValue
      })
      
      const response = await fetch(`/admin/contents/search.json?${params}`)
      const data = await response.json()
      
      this.showResults(data)
    } catch (error) {
      console.error("Autocomplete error:", error)
      this.hideResults()
    }
  }

  showResults(items) {
    if (!this.hasResultsTarget) return

    if (items.length === 0) {
      this.resultsTarget.innerHTML = '<div class="autocomplete-empty">No results found</div>'
    } else {
      this.resultsTarget.innerHTML = items.map(item => `
        <div class="autocomplete-item" data-value="${item.id}" data-action="click->autocomplete#select">
          <span class="autocomplete-name">${item.name}</span>
          <span class="autocomplete-type">${item.type}</span>
        </div>
      `).join("")
    }

    this.resultsTarget.classList.add("show")
  }

  hideResults() {
    if (this.hasResultsTarget) {
      this.resultsTarget.classList.remove("show")
    }
  }

  select(event) {
    const item = event.currentTarget
    const value = item.dataset.value
    const name = item.querySelector(".autocomplete-name").textContent

    this.inputTarget.value = value
    // Optionally show a display name
    this.inputTarget.dataset.displayName = name
    
    this.hideResults()
  }

  // Hide results when clicking outside
  disconnect() {
    this.hideResults()
  }
}
